import {
    css, Theme,
} from '@emotion/react'

const styles = (theme: Theme) => {
    return { root: css`
        padding: 20px;
        font-size: ${theme.typography.h3.fontSize}px;
        line-height: ${theme.typography.h3.lineHeight};
        color: ${theme.palette.secondary[600]};
    ` }
}

export default styles
